import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { formatNumber } from "../modules";
import { blue } from "@mui/material/colors";
import ApexCharts from "apexcharts";
import { notiError } from "../../utils/notiUltils";

function OverSpeed({ api, alarmReal }) {
  const theme = useTheme();
  const [dataSource, setDataSource] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [status, setStatus] = useState(true);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    const options = {
      chart: {
        type: "line",
        toolbar: {
          show: false,
        },
        height: 88,
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: 3,
      },

      series: [
        {
          name: "ความเร็วเกินกำหนด",
          data: dataSource,
        },
      ],
      tooltip: {
        enabled: false,
      },
      grid: {
        show: true,
        borderColor: "#90A4AE88",
        strokeDashArray: 6,
        position: "back",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },

      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        floating: true,
        //floating: false,
      },
      yaxis: {
        labels: {
          show: false,
        },
        floating: true,
      },
      markers: {
        discrete: [
          {
            seriesIndex: 0,
            dataPointIndex: 6,
            fillColor: theme.palette.mode === "dark" ? "#2d426a" : "#FFF",
            strokeColor: blue[500],
            strokeWidth: 2,
            size: dataSource[dataSource.length - 1] === 0 ? 0 : 6,
            shape: "circle",
          },
        ],
      },
    };
    const chart = new ApexCharts(document.querySelector("#chart2"), options);
    chart.render();
    setStatus(false);
    setTimeout(() => {
      setTotal(dataSource.reduce((s, c) => s + c, 0));
      setStatus(true);
    }, 100);

    return () => {
      chart.destroy();
    };
  }, [theme, dataSource]);

  useEffect(() => {
    api
      .get("/dashboard5", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api]);

  useEffect(() => {
    if (!alarmReal || alarmReal?.CategoryID !== 1) {
      return;
    }
    setDataSource((previusData) => {
      const tmp = [...previusData];
      typeof tmp[tmp.length - 1] === "number" && tmp[tmp.length - 1]++;
      return tmp;
    });
  }, [alarmReal]);

  return (
    <Card
      sx={{
        minHeight: 188,
        height: "100%",
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        className={status ? "animate__animated animate__bounceIn" : ""}
        title={`${formatNumber(total)} ครั้ง`}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ flexGrow: 1, py: 0, mt: -1 }}>
        <div id="chart2"></div>
      </CardContent>
      <CardActions sx={{ pt: 0, justifyContent: "center" }}>
        <Typography variant="body2" align="center" color="text.secondary">
          ความเร็วเกินกำหนด
        </Typography>
      </CardActions>
    </Card>
  );
}

export default OverSpeed;
